
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as day5nyu3d9kTLJstcsQQ4F5GMMxBu1t9UyzUXYkej1RAfkMeta } from "/vercel/path0/pages/calendar/day.vue?macro=true";
import { default as index5SX4l1zd0Hm0VOqIsgas2N00ui17MQm4dgkHfViLCdsMeta } from "/vercel/path0/pages/classi/index.vue?macro=true";
import { default as _91id_93CxC1ksA9i4IFC6zeoDOKVcWQePrBroYCt03dcK5ccSAMeta } from "/vercel/path0/pages/incomes/[id].vue?macro=true";
import { default as _91id_93x6c5odJ7e0dpn8WjIuUhEZ7T_45WtvDxCcmC2iNanD2yYMeta } from "/vercel/path0/pages/accounts/[id].vue?macro=true";
import { default as weekxu98hJ1Cbstw8jFMo9uyzh27OyLvO1lPStJ4pLEALmsMeta } from "/vercel/path0/pages/calendar/week.vue?macro=true";
import { default as _91slug_93EpnA464UV_AzOJXv5BVYphiD2_45bPBQbM8thQO3LyT5EMeta } from "/vercel/path0/pages/classi/[slug].vue?macro=true";
import { default as day_45customersel9_2ffgxw02anvPa0lbpB_454Xt_45DB_453fmBagGsZMD_EMeta } from "/vercel/path0/pages/day-customers.vue?macro=true";
import { default as index3I01mgP4OGR1mQjX_aWiaRevqsdTuwkREZG01x9otoEMeta } from "/vercel/path0/pages/incomes/index.vue?macro=true";
import { default as _91id_93Hr_j5r70lsUTqiTgG9IZFFoq_SHQYvr6RJnWR3y80qIMeta } from "/vercel/path0/pages/services/[id].vue?macro=true";
import { default as _91id_93oh7_TJ1CROBtLI4NDyWXuUF5JwM8bXTdgWiXqgBZdcUMeta } from "/vercel/path0/pages/trainers/[id].vue?macro=true";
import { default as indexOcn3huy2nvpLgHor5nXGDk1N6Zvlc1FT4gJ9ukCnd5YMeta } from "/vercel/path0/pages/accounts/index.vue?macro=true";
import { default as createPLduIDLMxKOd_45OLKlIzL15cJK2ITJukKWz9D7q6tHQAMeta } from "/vercel/path0/pages/incomes/create.vue?macro=true";
import { default as reset_45passwordsVav5yuNSbio4MDFK8_wlvNUllLjOKThNYu0CNyPrE0Meta } from "/vercel/path0/pages/reset-password.vue?macro=true";
import { default as indexfASyfYLZgR55h79sj4xJ_3Zfsayoukd227e7yRPtlF8Meta } from "/vercel/path0/pages/services/index.vue?macro=true";
import { default as indexAj73F1etqhU4xNHQ6_45rjU75bWRB4y0VTqSarJ5nui1YMeta } from "/vercel/path0/pages/trainers/index.vue?macro=true";
import { default as createNZHYp3GO5FfYMfICWF7_45Jwesx4chXIpVk4dasH2QoXEMeta } from "/vercel/path0/pages/accounts/create.vue?macro=true";
import { default as index_uvOFuLmXHqO3nhrRWh8UolFdPWeEuXgX_45WnTJwhmPkMeta } from "/vercel/path0/pages/customers/index.vue?macro=true";
import { default as forgot_45passwordYJWD0lcAfYaJTH90StowtOH8csR4uDHd8I_HNp6CgXIMeta } from "/vercel/path0/pages/forgot-password.vue?macro=true";
import { default as incomesKWZLdPzXIU8w33TzYO9xJID2_5DRv0SWxr0bzjk8DSwMeta } from "/vercel/path0/pages/reports/incomes.vue?macro=true";
import { default as createtP4yX2BEoVLtVz2cmtUuSbjz4d21vvrFmdeferxzUokMeta } from "/vercel/path0/pages/services/create.vue?macro=true";
import { default as createf6yNdPsu4xEFLx4FEUD6HvaTiv7_thcLlbwjfg9tuvUMeta } from "/vercel/path0/pages/trainers/create.vue?macro=true";
import { default as _91id_93OuKsjhzBDxIjmpLqJIzlKnryRr06opEPVt4GjMq2yMsMeta } from "/vercel/path0/pages/class-types/[id].vue?macro=true";
import { default as createPNWtsj_PlmBwoYz3UUUTtbNtW6vtZVDat2gE6QtAFLwMeta } from "/vercel/path0/pages/customers/create.vue?macro=true";
import { default as indexysMWqXQTsPjFjO9l5r2wtj_45SH0sjJxnCMXbq9wbG1uQMeta } from "/vercel/path0/pages/class-types/index.vue?macro=true";
import { default as profile2A4tG7pC9h_gqfl_45_45hzLjZso0CV7kkriAoAslir0xVcMeta } from "/vercel/path0/pages/customers/profile.vue?macro=true";
import { default as indexFKXmD1dNcO_Ayf8xYnGs5fTR9jK04uK_454RdACVKoDz8Meta } from "/vercel/path0/pages/evaluations/index.vue?macro=true";
import { default as customersMz0NhYXSIgyQ3AvaOB9CPbIYzoA8gM9Z1cj31hExfqcMeta } from "/vercel/path0/pages/reports/customers.vue?macro=true";
import { default as index4xdyltEEUIEj6OwrneeyRLJyv4Kdz479A_jpGeNentcMeta } from "/vercel/path0/pages/appointments/index.vue?macro=true";
import { default as createizhaZAZUVoykjK3zHAv37HMZYQjviG_z7qU7asD3qmcMeta } from "/vercel/path0/pages/class-types/create.vue?macro=true";
import { default as _91id_93290Vbu_U3jXw8S9zMClXkhyCTIW08XNawIiKbL6XQOUMeta } from "/vercel/path0/pages/library-media/[id].vue?macro=true";
import { default as _91id_93vNFrp3xsfrZr9KLEi9ePFhfFjCIkBqWoupkJYcNDr0YMeta } from "/vercel/path0/pages/trainer-wages/[id].vue?macro=true";
import { default as dashboardOi2zOEOzrFykTfLf65iKbUZrE_gflV6h9fxNkviXvKcMeta } from "/vercel/path0/pages/customers/dashboard.vue?macro=true";
import { default as index9g4RrjjkH5Z8tfRy4ar9Nr4UnKTOwvE5Vj0f4mDSSToMeta } from "/vercel/path0/pages/library-media/index.vue?macro=true";
import { default as indexyE7ibCDO9BXBVYWXLz83ARhhiRFys0bCOgxJjY4g35AMeta } from "/vercel/path0/pages/trainer-wages/index.vue?macro=true";
import { default as indexOWetyHzjxaPZdjm1wvHAR1LwHeFSWHnkdJs6vR2id4QMeta } from "/vercel/path0/pages/customers/[id]/index.vue?macro=true";
import { default as createVDhRWef3aggKc4XbsBQ2sZWIfEjeE4P7XjTUehx78v8Meta } from "/vercel/path0/pages/library-media/create.vue?macro=true";
import { default as change_45passwordxYTqYopBygXHVDvkYiBL_45h3jYtxhVt3FktYCCX8vbxMMeta } from "/vercel/path0/pages/user/change-password.vue?macro=true";
import { default as payment_45successIwZ0uUzwpLb5Y9SxwOwD9FHibAHA9lA0NmIngH43l7UMeta } from "/vercel/path0/pages/checkout/payment-success.vue?macro=true";
import { default as _91id_937n7JgzdVmBNxtubZ9DStCgAvZM1FCKK92PNTMmHp7RwMeta } from "/vercel/path0/pages/class-subscriptions/[id].vue?macro=true";
import { default as password_45reset_45link_45sentxPUiHnMB0mxg3VMCmkqeb3H8uZg2wunWVtQyskCNhKIMeta } from "/vercel/path0/pages/password-reset-link-sent.vue?macro=true";
import { default as active_45customersv1nMimk6zAq3xX_45AAacWLlvAXNcQqXYOhyBAzYU0U7kMeta } from "/vercel/path0/pages/reports/active-customers.vue?macro=true";
import { default as payment_45canceledUvD9a3Tskk8A_SZf_y4PWvm14cVOzPtm9GoMJrnqR6cMeta } from "/vercel/path0/pages/checkout/payment-canceled.vue?macro=true";
import { default as indexKz5Ku0rQFYSpfX7ut_452xsWt8CHGUcpLtvHPZPdepvdAMeta } from "/vercel/path0/pages/class-subscriptions/index.vue?macro=true";
import { default as createmx75djjzuUY9HmhUQoFL81sB1QACSQoQHNhlhD5KYqYMeta } from "/vercel/path0/pages/class-subscriptions/create.vue?macro=true";
import { default as evaluationsffyq6g6fgN_EbFYBHn81aADj2CJPa1Vcynmkni5glvwMeta } from "/vercel/path0/pages/customers/[id]/evaluations.vue?macro=true";
import { default as _91id_93cWHLXMIfNOVzsEWj0go2QSIDjbWgr9ZbCFMFMlAnsyQMeta } from "/vercel/path0/pages/library-media-collections/[id].vue?macro=true";
import { default as _91customer_id_93wIOEklksevSWeE_ej7_KwfXYf7VpSJxINIL7eNx8zhMMeta } from "/vercel/path0/pages/appointments/[id]/[customer_id].vue?macro=true";
import { default as index5ustBg_45DD5Kj0lNFuqHbfcUAmDA1j_45wpDailG4BYeWwMeta } from "/vercel/path0/pages/library-media-collections/index.vue?macro=true";
import { default as createm6JyxO827Pm_pJC3rUZERDVNl7xc_eAr5UE8S_45JoeQUMeta } from "/vercel/path0/pages/library-media-collections/create.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "calendar-day",
    path: "/calendar/day",
    meta: {"middleware":["not-customer"]},
    component: () => import("/vercel/path0/pages/calendar/day.vue")
  },
  {
    name: "classi",
    path: "/classi",
    component: () => import("/vercel/path0/pages/classi/index.vue")
  },
  {
    name: "incomes-id",
    path: "/incomes/:id()",
    meta: { ...(_91id_93CxC1ksA9i4IFC6zeoDOKVcWQePrBroYCt03dcK5ccSAMeta || {}), ...{"middleware":["account"]} },
    component: () => import("/vercel/path0/pages/incomes/[id].vue")
  },
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    meta: { ...(_91id_93x6c5odJ7e0dpn8WjIuUhEZ7T_45WtvDxCcmC2iNanD2yYMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/accounts/[id].vue")
  },
  {
    name: "calendar-week",
    path: "/calendar/week",
    meta: {"middleware":["not-customer"]},
    component: () => import("/vercel/path0/pages/calendar/week.vue")
  },
  {
    name: "classi-slug",
    path: "/classi/:slug()",
    meta: _91slug_93EpnA464UV_AzOJXv5BVYphiD2_45bPBQbM8thQO3LyT5EMeta || {},
    component: () => import("/vercel/path0/pages/classi/[slug].vue")
  },
  {
    name: "day-customers",
    path: "/day-customers",
    component: () => import("/vercel/path0/pages/day-customers.vue")
  },
  {
    name: "incomes",
    path: "/incomes",
    meta: {"middleware":["account"]},
    component: () => import("/vercel/path0/pages/incomes/index.vue")
  },
  {
    name: "services-id",
    path: "/services/:id()",
    meta: { ...(_91id_93Hr_j5r70lsUTqiTgG9IZFFoq_SHQYvr6RJnWR3y80qIMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/services/[id].vue")
  },
  {
    name: "trainers-id",
    path: "/trainers/:id()",
    meta: { ...(_91id_93oh7_TJ1CROBtLI4NDyWXuUF5JwM8bXTdgWiXqgBZdcUMeta || {}), ...{"middleware":["not-customer"]} },
    component: () => import("/vercel/path0/pages/trainers/[id].vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/accounts/index.vue")
  },
  {
    name: "incomes-create",
    path: "/incomes/create",
    meta: {"middleware":["account"]},
    component: () => import("/vercel/path0/pages/incomes/create.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(reset_45passwordsVav5yuNSbio4MDFK8_wlvNUllLjOKThNYu0CNyPrE0Meta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/reset-password.vue")
  },
  {
    name: "services",
    path: "/services",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/services/index.vue")
  },
  {
    name: "trainers",
    path: "/trainers",
    meta: {"middleware":["not-customer"]},
    component: () => import("/vercel/path0/pages/trainers/index.vue")
  },
  {
    name: "accounts-create",
    path: "/accounts/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/accounts/create.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/vercel/path0/pages/customers/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45passwordYJWD0lcAfYaJTH90StowtOH8csR4uDHd8I_HNp6CgXIMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/forgot-password.vue")
  },
  {
    name: "reports-incomes",
    path: "/reports/incomes",
    component: () => import("/vercel/path0/pages/reports/incomes.vue")
  },
  {
    name: "services-create",
    path: "/services/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/services/create.vue")
  },
  {
    name: "trainers-create",
    path: "/trainers/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/trainers/create.vue")
  },
  {
    name: "class-types-id",
    path: "/class-types/:id()",
    meta: { ...(_91id_93OuKsjhzBDxIjmpLqJIzlKnryRr06opEPVt4GjMq2yMsMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/class-types/[id].vue")
  },
  {
    name: "customers-create",
    path: "/customers/create",
    meta: {"middleware":["manager"]},
    component: () => import("/vercel/path0/pages/customers/create.vue")
  },
  {
    name: "class-types",
    path: "/class-types",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/class-types/index.vue")
  },
  {
    name: "customers-profile",
    path: "/customers/profile",
    component: () => import("/vercel/path0/pages/customers/profile.vue")
  },
  {
    name: "evaluations",
    path: "/evaluations",
    component: () => import("/vercel/path0/pages/evaluations/index.vue")
  },
  {
    name: "reports-customers",
    path: "/reports/customers",
    meta: {"middleware":["superadmin"]},
    component: () => import("/vercel/path0/pages/reports/customers.vue")
  },
  {
    name: "appointments",
    path: "/appointments",
    component: () => import("/vercel/path0/pages/appointments/index.vue")
  },
  {
    name: "class-types-create",
    path: "/class-types/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/class-types/create.vue")
  },
  {
    name: "library-media-id",
    path: "/library-media/:id()",
    meta: _91id_93290Vbu_U3jXw8S9zMClXkhyCTIW08XNawIiKbL6XQOUMeta || {},
    component: () => import("/vercel/path0/pages/library-media/[id].vue")
  },
  {
    name: "trainer-wages-id",
    path: "/trainer-wages/:id()",
    meta: {"middleware":["not-customer"]},
    component: () => import("/vercel/path0/pages/trainer-wages/[id].vue")
  },
  {
    name: "customers-dashboard",
    path: "/customers/dashboard",
    component: () => import("/vercel/path0/pages/customers/dashboard.vue")
  },
  {
    name: "library-media",
    path: "/library-media",
    component: () => import("/vercel/path0/pages/library-media/index.vue")
  },
  {
    name: "trainer-wages",
    path: "/trainer-wages",
    meta: {"middleware":["superadmin"]},
    component: () => import("/vercel/path0/pages/trainer-wages/index.vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    meta: { ...(indexOWetyHzjxaPZdjm1wvHAR1LwHeFSWHnkdJs6vR2id4QMeta || {}), ...{"middleware":["not-customer"]} },
    component: () => import("/vercel/path0/pages/customers/[id]/index.vue")
  },
  {
    name: "library-media-create",
    path: "/library-media/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/library-media/create.vue")
  },
  {
    name: "user-change-password",
    path: "/user/change-password",
    component: () => import("/vercel/path0/pages/user/change-password.vue")
  },
  {
    name: "checkout-payment-success",
    path: "/checkout/payment-success",
    component: () => import("/vercel/path0/pages/checkout/payment-success.vue")
  },
  {
    name: "class-subscriptions-id",
    path: "/class-subscriptions/:id()",
    meta: { ...(_91id_937n7JgzdVmBNxtubZ9DStCgAvZM1FCKK92PNTMmHp7RwMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/vercel/path0/pages/class-subscriptions/[id].vue")
  },
  {
    name: "password-reset-link-sent",
    path: "/password-reset-link-sent",
    meta: { ...(password_45reset_45link_45sentxPUiHnMB0mxg3VMCmkqeb3H8uZg2wunWVtQyskCNhKIMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/password-reset-link-sent.vue")
  },
  {
    name: "reports-active-customers",
    path: "/reports/active-customers",
    component: () => import("/vercel/path0/pages/reports/active-customers.vue")
  },
  {
    name: "checkout-payment-canceled",
    path: "/checkout/payment-canceled",
    component: () => import("/vercel/path0/pages/checkout/payment-canceled.vue")
  },
  {
    name: "class-subscriptions",
    path: "/class-subscriptions",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/class-subscriptions/index.vue")
  },
  {
    name: "class-subscriptions-create",
    path: "/class-subscriptions/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/class-subscriptions/create.vue")
  },
  {
    name: "customers-id-evaluations",
    path: "/customers/:id()/evaluations",
    meta: evaluationsffyq6g6fgN_EbFYBHn81aADj2CJPa1Vcynmkni5glvwMeta || {},
    component: () => import("/vercel/path0/pages/customers/[id]/evaluations.vue")
  },
  {
    name: "library-media-collections-id",
    path: "/library-media-collections/:id()",
    meta: _91id_93cWHLXMIfNOVzsEWj0go2QSIDjbWgr9ZbCFMFMlAnsyQMeta || {},
    component: () => import("/vercel/path0/pages/library-media-collections/[id].vue")
  },
  {
    name: "appointments-id-customer_id",
    path: "/appointments/:id()/:customer_id()",
    meta: _91customer_id_93wIOEklksevSWeE_ej7_KwfXYf7VpSJxINIL7eNx8zhMMeta || {},
    component: () => import("/vercel/path0/pages/appointments/[id]/[customer_id].vue")
  },
  {
    name: "library-media-collections",
    path: "/library-media-collections",
    component: () => import("/vercel/path0/pages/library-media-collections/index.vue")
  },
  {
    name: "library-media-collections-create",
    path: "/library-media-collections/create",
    meta: {"middleware":["admin"]},
    component: () => import("/vercel/path0/pages/library-media-collections/create.vue")
  }
]